import { useQuery } from '@tanstack/react-query'
import { agentsGridContract, createDataGridClient } from '@/modules/data-grid'
import { agentKeys } from '../../api/query-keys'

export const LONGEST_OFFLINE_LIMIT = 3

export function useAgentHealth(entityId: string) {
  return useQuery({
    queryKey: agentKeys.health(entityId),
    queryFn: async ({ signal }) => {
      const response = await createDataGridClient({
        contract: agentsGridContract,
        endpoint: `/api/v1/entities/${entityId}/agents`,
      }).query({
        query: {
          columns: ['name', 'agentId', 'entityId', 'lastOnlineAt'],
          filter: [{ column: 'status', operator: 'in', values: ['Offline'] }],
          sort: [{ column: 'lastOnlineAt', direction: 'asc' }],
          pagination: { limit: LONGEST_OFFLINE_LIMIT },
          facets: [{ column: 'status' }],
        },
        signal,
        parameters: { includeDescendants: true },
      })
      const statusCount = (status: 'Online' | 'Offline') =>
        response.facets?.status?.values?.find((facet) => facet.value === status)?.count ?? 0
      return {
        online: statusCount('Online'),
        offline: statusCount('Offline'),
        longestOffline: response.items,
      }
    },
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: 'always',
  })
}
